var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('keyboard-adaptation-wrapper', {
    staticClass: "editor-wrapper",
    style: Object.assign({
      border: '1px solid #000'
    }, _vm.rootStyles ? _vm.rootStyles : {}),
    attrs: {
      "minElementHeight": _vm.keyboardAdaptationWrapperMinElementHeight
    }
  }, [_vm.editor ? _c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "actions-container"
  }, [_c('div', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('bold')
    },
    attrs: {
      "disabled": !_vm.editor.can().chain().focus().toggleBold().run()
    },
    on: {
      "click": function ($event) {
        _vm.editor && _vm.editor.chain().focus().toggleBold().run();
      }
    }
  }, [_c('svg', {
    attrs: {
      "height": "30",
      "width": "30"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.boldSvg)
    }
  })]), _c('div', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('italic')
    },
    attrs: {
      "disabled": !_vm.editor.can().chain().focus().toggleItalic().run()
    },
    on: {
      "click": function ($event) {
        _vm.editor && _vm.editor.chain().focus().toggleItalic().run();
      }
    }
  }, [_c('svg', {
    attrs: {
      "height": "30",
      "width": "30"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.italicSvg)
    }
  })]), _c('div', {
    staticClass: "text-format-button",
    class: {
      'is-active': _vm.editor.isActive('underline')
    },
    attrs: {
      "disabled": !_vm.editor.can().chain().focus().toggleUnderline().run()
    },
    on: {
      "click": function ($event) {
        _vm.editor && _vm.editor.chain().focus().toggleUnderline().run();
      }
    }
  }, [_c('svg', {
    attrs: {
      "height": "30",
      "width": "30"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.svg.underlineSvg)
    }
  })])]), _vm.showMaxLength ? _c('span', {
    staticClass: "max-length-container"
  }, [_vm._v("\n      " + _vm._s(_vm.editor.storage.characterCount.characters()) + " of " + _vm._s(_vm.maxLength) + "\n    ")]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "editor-container",
    class: {
      isMobile: _vm.isMobile
    }
  }, [_c('editor-content', {
    attrs: {
      "editor": _vm.editor
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }